import {DataSourceInterface} from './datasource.interface.mjs';
import * as lib from "@mecatran/urbiplan-services-lib"

var {UrbiplanApiLib, UrbiplanApiConfig, urbiplanApiModel} = lib;

console.log('lib',lib);
console.log('urbiplanApiModel',urbiplanApiModel)

export function urbiplanApiDataSourceProvider(urbiplanApiConfig){
    var _lib = new UrbiplanApiLib();
    _lib.setConfig(urbiplanApiConfig);
    

    class UrbiplanApiAlertDataSource extends DataSourceInterface{
        constructor(mapAgencyRoute){
            var _map = mapAgencyRoute;
            super();

            Object.defineProperty(this,'mapAgencyRoute',{
                set : function(map){ _map = map },
                get : function(){ return _map }
            });


        }
        getTypedObject(){
            console.log('get')
            var map = this.getMapAgencyRoute();
            //return _lib.alerts().then((urbiplanApi)=>urbiplanApi.getAlerts()).then(this.filterAlertByAgencies(agencyIds))  // returns promise on  UrbiplanApi
            return _lib.alerts().then((urbiplanApi)=>urbiplanApi.getAlerts()).then(this.filterAlertsByMapAgencyRoutes(map))  // returns promise on  UrbiplanApi

        }

        filterAlertsByMapAgencyRoutes(map){
            return (alerts)=>{
                return alerts.filter((alert)=>{
                    /*
                    look at some routes of the alert (until decide to keep) 
                    for a route 
                    var agId = route.getAgency().getId(); 
                    if a map.has(route.agencyId) then 
                        agencyId = route.getAgency().getId(); 
                        routeIdSet = map.get(agencyId) 
                        if the values is empty keep the alert (routeIdSet.size === 0)
                        if the values is not empty check if the route.id is in the routeIdsSet
                        keep = map.has(agId) && (!map.get(agId).size || map.get(agId).has(routeId)) 
                        */
                    const routes = alert.getRoutes();
                    if (!routes || routes.length === 0) {
                            return false; // Or handle general alerts differently if needed
                    }
                    return routes.some(route =>{
                        const agencyId = route.getAgency().getId();
                        const routeIdSet = map.get(agencyId);
                        return (
                            routeIdSet && 
                            (routeIdSet.size === 0 || routeIdSet.has(route.getId()))
                        )
                    }) 
                });
            }
        }
        
/*
        filterAlertByAgencyAndRoutes(agencyId,routeIds){
            var filterAlertByAgencyIdAndRouteIds = urbiplanApiModel.UrbiplanApiActiveAlert.filterByAgencyIdAndRouteIds;
            return (alerts)=>{
                return filterAlertByAgencyIdAndRouteIds(alerts, agencyId, routeIds);
            }
        }

        filterAlertByAgencies(agencyIds){
            var filterAlertByAgencyIds = urbiplanApiModel.UrbiplanApiActiveAlert.filterByAgencyIds;
            return (alerts)=>{
                return filterAlertByAgencyIds(alerts,agencyIds);
            }
        }
*/

        setMapAgencyRoute(map){ this.mapAgencyRoute = map }

        getMapAgencyRoute(){ return this.mapAgencyRoute }

    }    


    class UrbiplanApiRouteDataSource extends DataSourceInterface{
        constructor(agencyIds){
            var _agencyIds = agencyIds;
            super();

            Object.defineProperty(this,'agencyIds',{
                set : function(ids){ _agencyIds = ids },
                get : function(){ return _agencyIds }
            });


        }
        getTypedObject(){
            console.log('get')
            var agencyIds = this.getAgencyIds();
            return _lib.routes()
                    .then((urbiplanApi)=>urbiplanApi.getRoutes())
                    .then(this.filterRouteByAgencies(agencyIds))    
                    .then(this.sorterByShortName())
        }

        filterRouteByAgencies(agencyIds){
            var filterRouteByAgencyIds = urbiplanApiModel.UrbiplanApiRoute.filterByAgencyIds;
            return (routes)=> filterRouteByAgencyIds(routes,agencyIds);
        }

        sorterByShortName(){
            var sorterByShortName = urbiplanApiModel.UrbiplanApiRoute.sorterByShortName;
            return (routes) => sorterByShortName(routes)
        }

        setAgencyIds(ids){ this.agencyIds = ids }

        getAgencyIds(){ return this.agencyIds }

    } 

    return {  UrbiplanApiAlertDataSource, UrbiplanApiRouteDataSource }

}

